import { useNavigate } from "react-router";
import * as S from './styles'

export const ContactSection = () => {
  const navigate = useNavigate();
  return (
    <S.Wrapper>
      <S.Card>
        <h4>
          Quer descobrir como aplicar isso no seu negócio?<br />Vamos conversar :)
        </h4>

        <S.ActionBtn
          onClick={() => navigate("/contato")}
          className="ActionBtnBottom"
        >
          Agende uma conversa gratuita
        </S.ActionBtn>
      </S.Card>
      <S.SectionShadow />
    </S.Wrapper>
  )
}
